import template from './ibanProperty.html';

export const ibanPropertyComponent = {
  restrict: 'E',
  template,
  controller: function () {
    'ngInject';

    this.$onInit = function () {
      const { value } = this;
      if (angular.isObject(value) && value.account) {
        this.ibanToggled = true;
      }
    };
  },
  controllerAs: 'vm',
  bindings: {
    value: '<',
  },
};
